import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { AppHeaderLogo } from '@/shared/components/layout';
import { LAYOUT_HEADER } from '@/shared/components/layout/tokens';
import { LANDING_NAV, LOGIN_PATH } from '../../domain/landingContent';
import { DemoCta, LoginCta } from './CtaButtons';

const TRANS = 'transition-all duration-500 ease-[cubic-bezier(0.32,0.72,0,1)]';

/** Header sticky da landing com âncoras e CTAs. */
export function LandingHeader() {
  const [menuAberto, setMenuAberto] = useState(false);

  useEffect(() => {
    if (!menuAberto) return;
    const fechar = () => setMenuAberto(false);
    window.addEventListener('hashchange', fechar);
    return () => window.removeEventListener('hashchange', fechar);
  }, [menuAberto]);

  return (
    <header className={`${LAYOUT_HEADER} pt-[env(safe-area-inset-top,0px)]`}>
      {/* 2 colunas abaixo de lg: o nav do meio é display:none e, no grid 1fr/auto/1fr
          do token, o botão cairia na coluna do centro. */}
      <div className="mx-auto grid h-14 w-full max-w-6xl grid-cols-[minmax(0,1fr)_auto] items-center gap-3 px-4 sm:h-16 sm:px-6 lg:grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)]">
        <div className="flex min-w-0 items-center">
          <Link to="/" className="shrink-0 rounded-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/20" aria-label="DS Espetos Grill — início">
            <AppHeaderLogo src="/LOGO.png" />
          </Link>
        </div>

        <nav
          className="hidden min-w-0 items-center justify-center gap-1 lg:flex"
          aria-label="Seções da página"
        >
          {LANDING_NAV.map(({ label, href }) => (
            <a
              key={href}
              href={href}
              className={`${TRANS} inline-flex min-h-11 items-center rounded-full px-3 text-xs font-medium text-slate-400 hover:bg-white/[0.05] hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/20 motion-reduce:transition-none`}
            >
              {label}
            </a>
          ))}
        </nav>

        <div className="flex items-center justify-end gap-2">
          <div className="hidden sm:block">
            <LoginCta loginPath={LOGIN_PATH} />
          </div>
          <div className="hidden md:block">
            <DemoCta />
          </div>

          <button
            type="button"
            onClick={() => setMenuAberto((v) => !v)}
            className="inline-flex min-h-11 min-w-11 shrink-0 items-center justify-center rounded-xl border border-white/10 bg-white/[0.04] text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/20 lg:hidden"
            aria-expanded={menuAberto}
            aria-label={menuAberto ? 'Fechar menu' : 'Abrir menu'}
          >
            {menuAberto ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {menuAberto && (
        <div className="border-t border-white/[0.06] bg-[#0a0a0f]/95 px-4 pt-4 pb-[max(1rem,env(safe-area-inset-bottom,0px))] backdrop-blur-md supports-[backdrop-filter]:bg-[#0a0a0f]/80 lg:hidden">
          <nav className="flex flex-col gap-1" aria-label="Menu mobile">
            {LANDING_NAV.map(({ label, href }) => (
              <a
                key={href}
                href={href}
                onClick={() => setMenuAberto(false)}
                className="inline-flex min-h-11 items-center rounded-xl px-4 text-sm font-medium text-slate-300 hover:bg-white/[0.05] hover:text-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white/20"
              >
                {label}
              </a>
            ))}
            <div className="mt-3 flex flex-col gap-2 border-t border-white/[0.06] pt-4">
              <DemoCta width="full" />
              <LoginCta loginPath={LOGIN_PATH} width="full" />
            </div>
          </nav>
        </div>
      )}
    </header>
  );
}
